import { Component, OnInit } from '@angular/core';
import * as firebase from 'firebase';
import { UsersService } from '../services/users.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessagesService } from '../services/messages.service';
import { Message } from '../models/message.model'





 



@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {

  constructor(public usersService: UsersService,private formBuilder: FormBuilder,public messagesService: MessagesService, ) { }

userToDisplay;
user;
userkey;
civ: string;
prenom: string;
name: string;
email: string;
 tel: string;
adresse_line1: string;
adresse_line2: string;
city: string;
zipcode: string;
login;
signupForm: FormGroup;
display_message: boolean =false;



initForm() {

    this.signupForm = this.formBuilder.group
    ({
Ctrl0: ['',Validators.required],
Ctrl1: ['',Validators.required],
      });


  }



  ngOnInit(): void {


    this.initForm();
  this.user = firebase.auth().currentUser;



          this.userToDisplay = this.usersService.getUserById(this.user.uid);
          
this.login=this.user.email;
              this.userToDisplay.subscribe((res: any) => {
              this.userkey = res[0].key; 
                    this.civ = res[0].civ; 
     this.prenom = res[0].prenom; 
     this.name = res[0].nom; 
     this.email = res[0].email; 
     this.tel = res[0].tel; 
     this.adresse_line1 = res[0].adresse_line1; 
     this.adresse_line2 = res[0].adresse_line2; 
     this.city = res[0].city; 
     this.zipcode = res[0].zipcode; 
    


    


  }
);
}




pay() {    



 const message = this.signupForm.get('Ctrl1').value;
 const objet = this.signupForm.get('Ctrl0').value;

 const date_created = Date.now().toString();


    const newMessage = new Message(
message,
objet,
date_created,
this.userkey,
this.civ,
this.prenom,
this.name,
this.email ,
this.tel ,
this.adresse_line1,
this.adresse_line2,
this.city,
this.zipcode,
this.login

);
    
this.messagesService.CreateNewMessage(newMessage);

this.display_message=true;
this.signupForm.reset();
 setInterval(() => {
    this.display_message=false; 
  }, 10000);
}



}